import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
// import { SemaforoPSInterface } from "../../../../../interfaces/SemaforoPSInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput, theme } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const CrearReporteFinalPresencial = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "REPORTE FINAL";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  // const querySemaforoPS = useGetData<SemaforoPSInterface>({
  //   url: `/semaforoPS/${evaluadosList_id}`,
  //   name: ["evaluado", `${evaluadosList_id}`, "semaforoPS"],
  // });

  const mutateSemaforoRGAAI = useMutationData({
    url: `/semaforo-reporte-presencial/${evaluadosList_id}`,
    reload: ["evaluado", "semaforo-reporte-presencial", `${evaluadosList_id}`],
  });

  const mutateFecha = useMutationData({
    url: `/fecha-reporte-presencial/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-reporte-presencial"],
  });

  const mutateMotivo = useMutationData({
    url: `/motivo-evaluacion-presencial/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "motivo-evaluacion-presencial"],
  });

  const mutateNotasRGAAI = useMutationData({
    url: `/notas-rfp/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "notas-rfp"],
  });

  const mutateResultadosRGAAI = useMutationData({
    url: `/resultados-rfp/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "resultados-rfp"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        fechae: queryEvaluado.data.fecha_evaluacione || "",
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        motivo: queryEvaluado.data.motivo_evaluacion || "",
        tipo: queryEvaluado.data.tipo_evaluacion || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div
      className={`space-y-4 p-4 ${
        isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"
      }`}
    >
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label
            htmlFor="fecha_evaluacione"
            className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}
          >
            FECHA EVALUACIÓN:
          </Label>
          <TextInput
            id="fecha_evaluacione"
            name="fecha_evaluacione"
            type="date"
            value={queryEvaluado.data?.fecha_evaluacione || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`text-center w-full ${
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }`}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label
            htmlFor="nombre"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            NOMBRE:
          </Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>

        {/* FOTO */}
        <div
          className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${
            isDarkMode
              ? "border-gray-600 bg-gray-800"
              : "border-gray-300 bg-gray-100"
          }`}
        >
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span
              className={`text-gray-500 ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              Sin foto disponible
            </span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label
              className={`flex items-center gap-2 mt-4 mb-4 ${
                isDarkMode ? "text-gray-200" : "text-gray-900"
              }`}
            >
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                onChange={handleRadioChange}
                className={
                  isDarkMode
                    ? "bg-gray-700 text-gray-200 border-gray-600"
                    : "bg-white text-gray-900 border-gray-300"
                }
              />
              RECOMENDABLE
            </label>
            <label
              className={`flex items-center gap-2 mt-12 mb-12 ${
                isDarkMode ? "text-gray-200" : "text-gray-900"
              }`}
            >
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                onChange={handleRadioChange}
                className={
                  isDarkMode
                    ? "bg-gray-700 text-gray-200 border-gray-600"
                    : "bg-white text-gray-900 border-gray-300"
                }
              />
              CON RESERVA
            </label>
            <label
              className={`flex items-center gap-2 mb-12 ${
                isDarkMode ? "text-gray-200" : "text-gray-900"
              }`}
            >
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                onChange={handleRadioChange}
                className={
                  isDarkMode
                    ? "bg-gray-700 text-gray-200 border-gray-600"
                    : "bg-white text-gray-900 border-gray-300"
                }
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label
            htmlFor="rfc"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            RFC:
          </Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label
            htmlFor="edad"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            EDAD:
          </Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label
            htmlFor="sexo"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            SEXO:
          </Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label
            htmlFor="estadoCivil"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            ESTADO CIVIL:
          </Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label
            htmlFor="escolaridad"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            ESCOLARIDAD:
          </Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label
            htmlFor="fechaNacimiento"
            className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}
          >
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }`}
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label
            htmlFor="curp"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            CURP:
          </Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label
            htmlFor="empresa"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            EMPRESA:
          </Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }
          />
        </div>
        {/* Motivo de la evaluación */}
        <div className="col-span-1">
          <Label
            htmlFor="motivo"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            MOTIVO DE LA EVALUACIÓN:
          </Label>
          <TextInput
            id="motivo_evaluacion"
            name="motivo_evaluacion"
            type="text"
            value={queryEvaluado.data?.motivo_evaluacion || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`w-full ${
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }`}
          />
        </div>

        <div className="col-span-1">
          <Label
            htmlFor="nota_4rfp"
            className={isDarkMode ? "text-gray-200" : "text-gray-900"}
          >
            TIPO:
          </Label>
          <TextInput
            id="tipo_evaluacion"
            name="tipo_evaluacion"
            type="text"
            value={queryEvaluado.data?.tipo_evaluacion || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`w-full ${
              isDarkMode
                ? "bg-gray-700 text-gray-200 border-gray-600"
                : "bg-white text-gray-900 border-gray-300"
            }`}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div
      className={`space-y-6 p-6 rounded-lg shadow-md ${
        isDarkMode ? "bg-gray-900 text-white" : "bg-gray-50 text-gray-900"
      }`}
    >
      <div
        className={`p-4 rounded-lg shadow ${
          isDarkMode ? "bg-blue-900 text-white" : "bg-customBlue text-white"
        }`}
      >
        <h2 className="font-bold text-xl">RESULTADO GENERAL</h2>
      </div>

      <div
        className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${
          isDarkMode
            ? "border-gray-600 bg-gray-800"
            : "border-gray-300 bg-gray-100"
        }`}
      >
        {/* Área para agregar notas */}
        <div className="w-full mt-4">
          <span
            className={`mb-2 text-justify block ${
              isDarkMode ? "text-gray-200" : "text-gray-900"
            }`}
          >
            Del contenido de las conclusiones que emite cada área de evaluación,
            se realizó una valoración, análisis y revisión con la finalidad de
            identificar los riesgos en conjunto, dado lo anterior se encontró lo
            siguiente en el proceso de evaluación.
          </span>
          <span
            className={`mb-2 text-justify block ${
              isDarkMode ? "text-gray-200" : "text-gray-900"
            }`}
          >
            Se considera que es una{" "}
            <strong>
              PERSONA{" "}
              <span className={isDarkMode ? "text-gray-200" : "text-gray-900"}>
                {selectedRecommendation === "recomendable"
                  ? "RECOMENDABLE"
                  : selectedRecommendation === "con_reserva"
                  ? "CON RESERVA"
                  : selectedRecommendation === "no_recomendable"
                  ? "NO RECOMENDABLE"
                  : "Selecciona una opción"}
              </span>
            </strong>
            <span
              className={`mt-2 mb-2 text-left font-medium text-base block ${
                isDarkMode ? "text-black-300" : "text-black-500"
              }`}
            >
              , en virtud de que al momento de{" "}
            </span>
            <Controller
              name="evaluacion_2rfp"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <textarea
                  id="evaluacion_2rfp"
                  {...field}
                  onInput={(e) => {
                    const target = e.target as HTMLTextAreaElement;
                    target.style.height = "auto";
                    target.style.height = `${target.scrollHeight}px`;
                  }}
                  style={{ height: "auto", overflow: "hidden" }}
                  rows={4}
                  placeholder="Escribe tus notas aquí..."
                  className={`w-full border rounded-lg p-2 focus:outline-none focus:border-blue-500 resize-none ${
                    isDarkMode
                      ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400"
                      : "bg-white text-gray-900 border-gray-300 placeholder-gray-500"
                  }`}
                />
              )}
            />{" "}
          </span>
          <span
            className={`mt-2 mb-2 text-left font-semibold text-lg block ${
              isDarkMode ? "text-blue-400" : "text-blue-600"
            }`}
          >
            RECOMENDACIÓN
          </span>
          <span
            className={`mt-2 mb-2 text-left font-medium text-base block ${
              isDarkMode ? "text-blue-300" : "text-blue-500"
            }`}
          >
            CON LA FINALIDAD DE APOYAR Y FORTALECER LA SEGURIDAD DE LAS EMPRESAS
            SE SUGIERE:
          </span>
          <Controller
            name="nota_3rfp"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                id="nota_3rfp"
                {...field}
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = "auto";
                  target.style.height = `${target.scrollHeight}px`;
                }}
                style={{ height: "auto", overflow: "hidden" }}
                rows={4}
                placeholder="Escribe tus notas aquí..."
                className={`w-full border rounded-lg p-2 focus:outline-none focus:border-blue-500 resize-none ${
                  isDarkMode
                    ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400"
                    : "bg-white text-gray-900 border-gray-300 placeholder-gray-500"
                }`}
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}
    >
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
              recomendacion: selectedRecommendation,
              color_semaforo:
                selectedRecommendation === "recomendable"
                  ? "verde"
                  : selectedRecommendation === "con_reserva"
                  ? "amarillo"
                  : selectedRecommendation === "no_recomendable"
                  ? "rojo"
                  : "",
            };

            // Mutación para guardar la Fecha de Reporte General del Area de Análisis
            mutateFecha.mutate(
              {
                data: {},
                tipo: "post",
              },
              {
                onSuccess: () => {
                  mutateSemaforoRGAAI.mutate(
                    {
                      data: formData,
                      tipo: "post",
                    },
                    {
                      onSuccess: () => {
                        // Mutación para guardar Motivo de evaluación
                        mutateMotivo.mutate(
                          {
                            data: formData,
                            tipo: "post",
                          },
                          {
                            onSuccess: () => {
                              // Mutación para guardar Notas RGAAI
                              mutateNotasRGAAI.mutate(
                                {
                                  data: formData,
                                  tipo: "post",
                                },
                                {
                                  onSuccess: () => {
                                    // Mutación para guardar Resultados RGAAI
                                    mutateResultadosRGAAI.mutate(
                                      {
                                        data: formData,
                                        tipo: "post",
                                      },
                                      {
                                        onSuccess: () => {
                                          navigate(
                                            `/evaluaciones/presencial/reporte-final/${evaluadosList_id}`
                                          );
                                        },
                                        onError: (error) => {
                                          console.error(
                                            "Error al guardar Resultados RGAAI:",
                                            error
                                          );
                                        },
                                      }
                                    );
                                  },
                                  onError: (error) => {
                                    console.error(
                                      "Error al guardar Notas RGAAI:",
                                      error
                                    );
                                  },
                                }
                              );
                            },
                            onError: (error) => {
                              console.error(
                                "Error al guardar Motivo de Evaluación:",
                                error
                              );
                            },
                          }
                        );
                      },
                      onError: (error) => {
                        console.error(
                          "Error al guardar Semaforo RGAAI:",
                          error
                        );
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Reporte General:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${
            isDarkMode ? "bg-gray-800" : "bg-white"
          }`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar en renderPage1 (lado izquierdo) */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(
                    `/evaluaciones/presencial/reporte-final/${evaluadosList_id}`
                  );
                }}
                className={`ml-2 ${
                  isDarkMode
                    ? "bg-red-700 hover:bg-red-800 text-white"
                    : "bg-red-500 hover:bg-red-600 text-white"
                }`}
              >
                Cancelar
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  handlePageChange(currentPage - 1);
                  window.scrollTo(0, 0);
                }}
                className={`ml-2 ${
                  isDarkMode
                    ? "bg-violet-700 hover:bg-violet-800 text-white"
                    : "bg-violet-500 hover:bg-violet-600 text-white"
                }`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Siguiente en renderPage1 (lado derecho) */}
            {currentPage < 2 && (
              <Button
                className={`ml-2 ${
                  isDarkMode
                    ? "bg-blue-700 hover:bg-blue-800 text-white"
                    : "bg-blue-500 hover:bg-blue-600 text-white"
                }`}
                onClick={() => {
                  handlePageChange(currentPage + 1);
                  window.scrollTo(0, 0);
                }}
              >
                Siguiente
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button
                  type="submit"
                  className={`ml-2 ${
                    isDarkMode
                      ? "bg-green-700 hover:bg-green-800 text-white"
                      : "bg-green-500 hover:bg-green-600 text-white"
                  }`}
                >
                  Guardar
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
